"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.setOption = void 0;
const function_1 = require("fp-ts/function");
const Optional_1 = require("monocle-ts/Optional");
const Traversal_1 = require("monocle-ts/Traversal");
const monocle_1 = require("../util/monocle");
const setOption = (path, ...args) => (obj) => {
    const indicies = args.slice(0, args.length - 1);
    const val = args[args.length - 1];
    if ((0, monocle_1.isPathLens)(path)) {
        return (0, monocle_1.lensFromPath)(path).set(val)(obj);
    }
    if ((0, monocle_1.isPathTraversal)(path)) {
        return (0, function_1.pipe)((0, monocle_1.traversalFromPath)(path, indicies), (0, Traversal_1.set)(val))(obj);
    }
    return (0, function_1.pipe)((0, monocle_1.optionalFromPath)(path, indicies), (0, Optional_1.setOption)(val))(obj);
};
exports.setOption = setOption;
